/* eslint-disable no-dupe-keys */
import { useState } from 'react';
import { useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { Icon } from '@iconify/react';

import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';

import { editItem, getItem, deleteItemWithBody } from '../../fetch';
import { useEffectAsync } from '../../reactHelper';
import { useTranslation } from '../../common/LocalizationProvider';
import { PermissionDialog } from '../permission';
import { selectUsersArray } from '../../createSelectorUtils';

UserLinkedUser.propTypes = {
  userId: PropTypes.number.isRequired
};
export default function UserLinkedUser({ userId }) {
  const t = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const allUser = useSelector(selectUsersArray);
  const [linkedUser, setLinkedUser] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  useEffectAsync(async () => {
    if (isOpen) {
      const response = await getItem(`users?userId=${userId}`);
      if (response.ok) {
        setLinkedUser(await response.json());
      }
    }
  }, [isOpen]);

  const handleChange = async (event) => {
    const newUser = allUser.find((item) => item.id === parseInt(event.target.value, 10));
    if (newUser) {
      const create = !linkedUser.map((item) => item.id).includes(newUser.id);
      const response = create
        ? await editItem('permissions', undefined, {
            userId,
            userId: newUser.id
          })
        : await deleteItemWithBody('permissions', {
            userId,
            userId: newUser.id
          });
      if (response.ok) {
        setLinkedUser(
          create ? [...linkedUser, newUser] : linkedUser.filter((item) => item.id !== newUser.id)
        );
      } else {
        const error = await response.text();
        const message = error.slice(0, error.indexOf('-'));
        enqueueSnackbar(message, { variant: 'error' });
      }
    }
  };

  return (
    <>
      <MenuItem sx={{ color: 'text.secondary' }} onClick={() => setIsOpen(true)}>
        <ListItemIcon>
          <Icon icon="clarity:group-solid" width={24} height={24} />
        </ListItemIcon>
        <ListItemText
          primary={t('UL_Menu_Linked_Users')}
          primaryTypographyProps={{ variant: 'body2' }}
        />
      </MenuItem>

      <PermissionDialog
        title="UL_Menu_Linked_Users"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        handleChange={handleChange}
        allObject={allUser}
        linkedObject={linkedUser}
      />
    </>
  );
}
